import { render, staticRenderFns } from "./systemUpdateNotice.vue?vue&type=template&id=e1f75842&scoped=true"
import script from "./systemUpdateNotice.vue?vue&type=script&lang=js"
export * from "./systemUpdateNotice.vue?vue&type=script&lang=js"
import style0 from "./systemUpdateNotice.vue?vue&type=style&index=0&id=e1f75842&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1f75842",
  null
  
)

export default component.exports